/**
 * Shared indentation constants for the navbar tree, manage-boards modal,
 * and move-to-folder modal. Levels 0-6 each get a unique indent; anything
 * deeper clamps to level 6 — by design, users nesting that deep should
 * expect the UI to lose per-level distinction.
 */
export const TREE_INDENT_BASE_PX = 8;
export const TREE_INDENT_PER_LEVEL_PX = 24;
export const TREE_INDENT_MAX_LEVEL = 6;

export function getTreeIndentPx(depth: number): number {
	const clamped = Math.min(Math.max(depth, 0), TREE_INDENT_MAX_LEVEL);
	return TREE_INDENT_BASE_PX + clamped * TREE_INDENT_PER_LEVEL_PX;
}

export function readTreeOpenState(key: string): Record<string, boolean> {
	try {
		return JSON.parse(localStorage.getItem(key) ?? "{}") as Record<
			string,
			boolean
		>;
	} catch {
		return {};
	}
}
